<template>
  <div class="cell">
    <div class="head">
      <div class="label">
        <div class="title">{{ source.drawCashNo }}</div>
        <div class="time">
          {{
            source.applyTime &&
            dayjs(source.applyTime).format('YYYY-MM-DD HH:mm:ss')
          }}
        </div>
      </div>
      <div class="value">
        <div
          class="tip"
          :class="[source.drawCashStatus ? 'green' : 'red']"
        >
          {{ source.drawCashStatus ? '提现成功' : '提现失败' }}
        </div>
        <div class="amount">
          ¥&nbsp;{{ source.drawCashSum | amount }}
        </div>
      </div>
    </div>
    <div
      class="detail van-hairline--top"
      v-if="!source.drawCashStatus"
    >
      <div class="tip">提现失败原因：</div>
      <div class="value">{{ source.drawCashFailedReason }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    source: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="less" scoped>
.cell {
  box-shadow: 0px 4px 12px 0px rgba(153, 153, 153, 0.05);
  border-radius: 12px;
  padding: 0;
  background: #fff;
  &::after {
    display: none;
  }
  & + .cell {
    margin-top: 24px;
  }
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 32px;
    .label {
      .title {
        font-size: 28px;
        line-height: 28px;
      }
      .time {
        font-size: 24px;
        color: #808080;
        line-height: 24px;
        padding-top: 16px;
      }
    }
    .value {
      text-align: right;
      .tip {
        font-size: 28px;
        line-height: 28px;
        &.green {
          color: #8ad300;
        }
        &.red {
          color: #e82035;
        }
      }
      .amount {
        margin-top: 8px;
        font-size: 28px;
        line-height: 28px;
      }
    }
  }
  .detail {
    display: none;
    font-size: 24px;
    color: #666666;
    line-height: 24px;
    padding: 32px;
  }
}
</style>